'use client'

import { useCallback, useEffect, useState } from 'react'

// eslint-disable-next-line no-unused-vars
type FullscreenCallback = (_isFullscreen: boolean) => void

export const useFullscreen = (
  callback?: FullscreenCallback,
): {
  isFullscreen: boolean
  toggleFullscreen: () => void
} => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const enterFullscreen = useCallback(() => {
    const elem = document.documentElement
    if (elem.requestFullscreen) {
      elem.requestFullscreen()
    }
    setIsFullscreen(true)
    if (callback) callback(true)
  }, [callback])

  const exitFullscreen = useCallback(() => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    }
    setIsFullscreen(false)
    if (callback) callback(false)
  }, [callback])

  const toggleFullscreen = useCallback(() => {
    if (!isFullscreen) {
      enterFullscreen()
    } else {
      exitFullscreen()
    }
  }, [enterFullscreen, exitFullscreen, isFullscreen])

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement))
    }
    document.addEventListener('fullscreenchange', onFullscreenChange)
    return () =>
      document.removeEventListener('fullscreenchange', onFullscreenChange)
  }, [])

  return { isFullscreen, toggleFullscreen }
}

export default useFullscreen
